var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPodcastPage = function SvgPodcastPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.636 3.667h12.728a1.97 1.97 0 0 1 1.97 1.97v12.727a1.97 1.97 0 0 1-1.97 1.97H5.636a1.97 1.97 0 0 1-1.97-1.97V5.636a1.97 1.97 0 0 1 1.97-1.97M2 5.637A3.636 3.636 0 0 1 5.636 2h12.728A3.636 3.636 0 0 1 22 5.636v12.728A3.636 3.636 0 0 1 18.364 22H5.636A3.636 3.636 0 0 1 2 18.364zm8.248 1.754a1.753 1.753 0 0 1 3.506 0v4.593a1.753 1.753 0 0 1-3.506 0zM7.91 11.999v.003c0 2.04 1.524 3.73 3.508 4.009v1.198H9.662v1.157h4.675v-1.157h-1.75V16.01c1.981-.282 3.504-1.97 3.504-4.009v-.001h.002v-1.736h-1.168V12h-.002v.002c0 1.597-1.308 2.892-2.922 2.892S9.08 13.598 9.08 12.001h.003v-1.736H7.913V12z",
    clipRule: "evenodd"
  })));
};
export default SvgPodcastPage;